import { types } from '../../../types/types';

export const reducerPesquisaItem = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PESQUISA_ITEM:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}